import { render, staticRenderFns } from "./DistributorFeatureTable.vue?vue&type=template&id=182bf3f8"
import script from "./DistributorFeatureTable.vue?vue&type=script&lang=js"
export * from "./DistributorFeatureTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports